<template>
  <div id="orderInsert" class="q-pa-md">
    <PageHeader content="应收帐款" />

    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="应收帐款" name="first">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="8">
              <CustSelector ref="custSelector" />
            </el-col>
            <el-col :span="8">
              <el-form-item label="价税合计">
                <el-input
                  v-model="form.total"
                  type="number"
                  step="0.01"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="税率">
                <el-input v-model="form.taxRate"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="税额">
                <el-input v-model="form.tax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="金额">
                <el-input
                  v-model="form.amount"
                  type="number"
                  step="0.01"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票状态" prop="invoiceStatus">
                <el-select
                  v-model="form.invoiceStatus"
                  placeholder="请选择开票状态"
                  style="width: 100%"
                  clearable
                >
                  <el-option label="未开票" value="0"></el-option>
                  <el-option label="已开票" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="开票日期">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.invoiceDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="已收金额">
                <el-input
                  v-model="form.amountPaid"
                  type="number"
                  step="0.01"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="未收金额">
                <el-input
                  v-model="form.amountBalance"
                  type="number"
                  step="0.01"
                  clearable
                >
                  <el-button slot="append" @click="calcBalance">计算</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="状态" prop="status">
                <el-select
                  v-model="form.status"
                  placeholder="请选择应收帐款状态"
                  style="width: 100%"
                  clearable
                >
                  <el-option label="未付款" value="0"></el-option>
                  <el-option label="部分付款" value="1"></el-option>
                  <el-option label="已结清" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="发票附件">
                <Upload ref="upload" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  v-model="form.remark"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button type="primary" @click="saveReceivable">保存</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane v-if="form.id" label="应收帐款明细" name="second">
        <div class="tab">
          <el-button @click="addDetail">添加</el-button>
          <el-table :data="details.list" style="width: 90%" border>
            <el-table-column prop="payDate" label="日期"></el-table-column>
            <el-table-column prop="type" label="类型"></el-table-column>
            <el-table-column prop="amount" label="金额"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="receDetail(scope.row)"
                  >详情</el-button
                >
                <el-button size="mini" type="danger" @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="queryReceivableDetails"
            @size-change="queryReceivableDetails"
            :current-page.sync="queryDetailsForm.pageNum"
            :page-size.sync="queryDetailsForm.pageSize"
            :page-sizes="[10, 20, 30, 40, 50]"
            :total="details.total"
            layout="total,sizes, prev, pager, next"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="form.id" label="货物清单" name="third">
        <div class="tab">
          <el-button>添加</el-button>
          <el-button
            @click="
              itemsVisible = true;
              queryDeliveryItem();
            "
            >生成</el-button
          >
          <el-button @click="exportReceivableItem">导出</el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            @click="queryReceivableItems"
          ></el-button>
          <el-table
            :data="items.list"
            style="width: 90%"
            border
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              prop="deliveryItem.orderInfo.orderDate"
              label="订单日期"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="deliveryItem.orderInfo.customerOrderNo"
              label="客户订单号"
            ></el-table-column>
            <el-table-column prop="itemName" label="货物名称"></el-table-column>
            <el-table-column
              prop="deliveryItem.deliveryNote.deliveryDate"
              label="送货日期"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="deliveryItem.cylNo"
              label="缸号"
              width="100"
            ></el-table-column>
            <el-table-column prop="spec" label="规格型号"></el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"
              width="100"
              :formatter="numFormatter"
            ></el-table-column>
            <el-table-column
              prop="unitPrice"
              label="单价(含税)"
              width="100"
              :formatter="numFormatter"
            ></el-table-column>
            <el-table-column
              prop="total"
              label="金额(含税)"
              width="100"
              :formatter="numFormatter"
            ></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="receivableItem(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="removeItem(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="queryReceivableItems"
            @size-change="queryReceivableItems"
            :current-page.sync="queryItemsForm.pageNum"
            :page-size.sync="queryItemsForm.pageSize"
            :page-sizes="[10, 20, 30, 40, 50]"
            :total="items.total"
            layout="total,sizes, prev, pager, next"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog width="80%" title="选择货物清单" :visible.sync="itemsVisible">
      <el-form
        id="itemsDialogQueryForm"
        :model="itemsDialogQueryForm"
        label-width="100px"
      >
        <el-row :gutter="30">
          <el-col :span="6">
            <el-form-item label="订单编号">
              <el-input v-model="itemsDialogQueryForm.orderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="缸号">
              <el-input v-model="itemsDialogQueryForm.cylinderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="送货开始日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="itemsDialogQueryForm.beginTime"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="送货结束日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="itemsDialogQueryForm.endTime"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="18">
            <el-form-item>
              <el-button type="primary" @click="resetItemsDialogQueryForm"
                >重置</el-button
              >
              <el-button
                type="primary"
                @click="
                  itemsDialogQueryForm.pageNum = 1;
                  itemsDialogQueryForm.pageSize = 10;
                  queryDeliveryItem();
                "
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="4">
          <el-button type="primary" size="mini" @click="selectAllItems"
            >全选</el-button
          >
          <el-button type="primary" size="mini" @click="reverseItems"
            >反选</el-button
          >
          <el-button type="danger" size="mini" @click="clearItems"
            >取消</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="itemTable.list"
        ref="itemTable"
        style="width: 100%"
        highlight-current-row
        border
        :default-sort="{ prop: 'customer', order: 'descending' }"
        @row-click="selectItem"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          label="送货日期"
          prop="deliveryNote.deliveryDate"
          width="100"
        ></el-table-column>
        <el-table-column
          label="订单编号"
          prop="orderNo"
          width="150"
        ></el-table-column>
        <el-table-column label="类型" prop="orderNo" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.orderInfo.delivery == '是'">购销</span>
            <span v-else>加工</span>
          </template>
        </el-table-column>
        <el-table-column
          label="缸号"
          prop="cylNo"
          width="100"
        ></el-table-column>
        <el-table-column label="纱支原料" prop="yarn"></el-table-column>
        <el-table-column label="颜色" prop="color" width="80"></el-table-column>
        <el-table-column
          label="色号"
          prop="colorNo"
          width="80"
        ></el-table-column>
        <el-table-column label="加工" prop="process"></el-table-column>
        <el-table-column
          label="投染数"
          prop="productWeight"
          width="80"
          :formatter="numFormatter"
        ></el-table-column>
        <el-table-column
          label="净重"
          prop="netWeight"
          width="80"
          :formatter="numFormatter"
        ></el-table-column>
        <el-table-column
          label="单价"
          prop="price"
          width="80"
          :formatter="numFormatter"
        ></el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <el-pagination
        @current-change="queryDeliveryItem"
        @size-change="queryDeliveryItem"
        :current-page.sync="itemsDialogQueryForm.pageNum"
        :page-size.sync="itemsDialogQueryForm.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        :total="itemTable.total"
        layout="total,sizes, prev, pager, next"
      ></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="itemsVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectItems">确 定</el-button>
      </div>
    </el-dialog>
    <rece-detail
      :visible.sync="detailVisible"
      :receDetail="detail"
    ></rece-detail>
  </div>
</template>

<script>
import { removeItem } from "@/api/erp/finance/receivable";
import CustSelector from "@/components/CustSelector.vue";
import PageHeader from "@/components/PageHeader.vue";
import Upload from "@/components/Upload.vue";
import receDetail from "./receDetailDialog";
import numbro from "numbro";
export default {
  components: {
    CustSelector,
    PageHeader,
    Upload,
    receDetail,
  },
  data() {
    return {
      form: {},
      activeName: "first",
      queryDetailsForm: { pageNum: 1, pageSize: 10 },
      detailsDialogQueryForm: { pageNum: 1, pageSize: 10 },
      details: {}, //应收帐款详情列表
      detail: {}, //应收帐款详情弹出框参数
      detailVisible: false, //应收帐款详情dialog
      queryItemsForm: { pageNum: 1, pageSize: 10 },
      itemsDialogQueryForm: { pageNum: 1, pageSize: 10 },
      itemsVisible: false,
      itemTable: {},
      items: { sumMap: {} },
      rules: {
        invoiceStatus: [
          { required: true, message: "开票状态不能为空", trigger: "change" },
        ],
        status: [
          {
            required: true,
            message: "应收帐款状态不能为空",
            trigger: "change",
          },
        ],
        customerNo: [
          { required: true, message: "客户不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.queryReceivable(this.$route.params.id);
      this.queryReceivableItems();
    }
  },
  methods: {
    saveReceivable() {
      console.log("save");
      this.form.customerNo = this.$refs.custSelector.customerNo;
      this.form.invoice = JSON.stringify(this.$refs.upload.fileList);
      var self = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (self.form.id) {
            this.$axios
              .post("/receivable/update", self.form)
              .then(function (response) {
                if (response.data.errorCode == "00000") {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });
                  //查询应收帐款详情
                  self.queryReceivable(self.form.id);
                } else {
                  self.$message.error(response.data.errorMsg);
                }
              });
          } else {
            this.$axios
              .post("/receivable/save", self.form)
              .then(function (response) {
                if (response.data.errorCode == "00000") {
                  self.$message({
                    message: "创建成功",
                    type: "success",
                  });
                  //查询应收帐款详情
                  // self.queryReceivable(response.data.data);
                  self.$router.push("/receivable/detail/" + response.data.data);
                } else {
                  self.$message.error(response.data.errorMsg);
                }
              });
          }
        }
      });
    },
    queryReceivable(id) {
      var self = this;
      this.$axios.get("/receivable/" + id).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form = response.data.data;
          self.$refs.custSelector.customerNo = self.form.customerNo;
          if (self.form.invoice) {
            self.$refs.upload.fileList = JSON.parse(self.form.invoice);
          }
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    cancel() {
      console.log("cancel");
    },
    queryReceivableDetails() {
      console.log("查询应收帐款明细");
    },
    queryReceivableItems() {
      console.log("查询货物清单");
      this.queryItemsForm.receiveId = this.$route.params.id;
      var self = this;
      this.$axios
        .get("/receivable/item/list", { params: self.queryItemsForm })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.items = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    removeItem(row) {
      console.log("删除清单" + row.id);
      var self = this;
      this.$confirm("此操作将永久删除该笔清单并无法恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeItem(row.id).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$message({
                message: "删除成功",
                type: "success",
              });
              self.queryReceivableItems();
            } else {
              self.$message.error(response.data.errorMsg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 全选
    selectAllItems() {
      if (this.itemTable.list) {
        this.itemTable.list.forEach((row) => {
          this.$refs.itemTable.toggleRowSelection(row, true);
        });
      }
    },
    //反选
    reverseItems() {
      if (this.itemTable.list) {
        this.itemTable.list.forEach((row) => {
          this.$refs.itemTable.toggleRowSelection(row);
        });
      }
    },
    //点击切换选中状态
    selectItem(row) {
      this.$refs.itemTable.toggleRowSelection(row);
    },
    //清空
    clearItems() {
      this.$refs.itemTable.clearSelection();
    },
    resetItemsDialogQueryForm() {
      this.itemsDialogQueryForm = { pageNum: 1, pageSize: 10 };
    },
    queryDeliveryItem() {
      console.log("查询货物清单");
      var self = this;
      self.itemsDialogQueryForm["customer.customerNo"] = self.form.customerNo;
      this.$axios
        .get("/receivable/delivery/item/list", {
          params: self.itemsDialogQueryForm,
        })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.itemTable = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    selectItems() {
      console.log("加入清单");
      var self = this;
      var receivableItem = {
        receivableId: this.form.id,
        receivableItems: this.$refs.itemTable.selection,
      };
      this.$axios
        .post("/receivable/item/save", receivableItem)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.$message({
              message: "更新成功",
              type: "success",
            });
            //查询应收帐款货物清单
            self.queryReceivableItems();
            //刷新待选列表
            self.queryDeliveryItem();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    calcBalance() {
      var amountBalance = (this.form.total || 0) - (this.form.amountPaid || 0);
      this.$set(this.form, "amountBalance", amountBalance);
    },
    numFormatter(row, column, cellValue) {
      if (cellValue) {
        return numbro(cellValue).format({
          thousandSeparated: true,
          mantissa: 2,
        });
      }
    },
    getSummaries() {
      // this.tableData;
      var sums = [];
      sums[0] = "合计";
      sums[1] = "N/A";
      sums[2] = "N/A";
      sums[3] = "N/A";
      sums[4] = "N/A";
      sums[5] = "N/A";
      sums[6] = numbro(this.items.sumMap.totalQuantity || 0).format({
        thousandSeparated: true,
        mantissa: 2,
      }); //数量合计
      sums[7] = "N/A";
      sums[8] = numbro(this.items.sumMap.total || 0).format({
        thousandSeparated: true,
        mantissa: 2,
      }); //金额合计
      sums[9] = "N/A";
      return sums;
    },
    exportReceivableItem() {
      var receId = this.$route.params.id;
      this.$axios
        .get("/receivable/item/export?receiveId=" + receId, {
          responseType: "blob",
        })
        .then((res) => {
          if (!res) {
            this.$message.error("导出清单失败");
            return false;
          }
          const blob = new Blob([res.data]);
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          //let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          //let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          //let result = patt.exec(contentDisposition);
          // let filename = decodeURI(result[1]);
          let filename = '对账单.xlsx';
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        });
    },
    addDetail() {
      console.log("添加收款详情");
      this.detail = { receiveId: this.form.id };
      this.detailVisible = true;
    },
  },
};
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tabs {
  margin-top: 20px;
  background-color: white;
}
/* .el-tab-pane {
  background-color: white;
} */
.el-table {
  margin: 0 auto;
}
#tab {
  margin-top: 20;
}
</style>